import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import {
  HeadingText,
  BodyText,
  ArrowRightIcon,
  Button,
} from '@paypalcorp/pp-react';
import { appendCdnHostName } from '../../../../utility/geoUtils';

const Campaign = ({ information, handleLogin, imgSrc, inverted }) => {
  const getStartCampaignContent = () => {
    const listItems = get(information, 'list', {});

    return Object.keys(listItems).map((key) => listItems[key]);
  };

  const classes = classNames({
    'campaign-container': true,
    'campaign-container-inverted': inverted,
  });

  return (
    <div className={classes}>
      <div className="image-container">
        <img src={appendCdnHostName(imgSrc)} />
      </div>
      <div className="description-container">
        <HeadingText size="lg" className="description-title">
          {information.title}
        </HeadingText>
        <BodyText className="description-paragraph">
          {information.paragraph}
        </BodyText>
        <ul className="description-list">
          {getStartCampaignContent().map((item, key) => (
            <li key={key}>
              <BodyText>{item}</BodyText>
            </li>
          ))}
        </ul>
        <Button className="description-button" onClick={handleLogin} tertiary>
          {information.button}{' '}
          <ArrowRightIcon className="description-button-icon" size="sm" />
        </Button>
      </div>
    </div>
  );
};

Campaign.propTypes = {
  information: PropTypes.object,
  handleLogin: PropTypes.func,
  imgSrc: PropTypes.string,
  inverted: PropTypes.bool,
};

export default Campaign;
